import React, {Component} from 'react';
import {browserHistory, Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {loginUser, fetchUser, loginWithProvider} from '../../actions/firebase_actions';


class UserLogin extends Component {

    constructor(props) {
        super(props);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.loginWithProvider = this.loginWithProvider.bind(this);
        this.translateMessage = this.translateMessage.bind(this);
        this.state = {
            message: '',
        };
    }

    translateMessage(message) {
        console.log(message);
        switch (message) {
            case 'The email address is already in use by another account.':
                return 'Email je už zaregistrovaný';
            case 'Password should be at least 6 characters':
                return 'Heslo by malo obsahovať aspoň 6 znakov';
            case 'The email address is badly formatted.':
                return 'Zadaj správny email';
            case 'The password must be 6 characters long or more.':
                return "Heslo musí obsahovať aspoň 6 znakov.";
            case 'The password is invalid or the user does not have a password.':
                return 'Nesprávny email alebo heslo. ';
            case 'There is no user record corresponding to this identifier. The user may have been deleted.':
                return 'Neexistuje záznam o tomto uživateľovi. Tento uživateľ mohol byť zmazaný.';
            default:
                return message;
        }
    }

    onFormSubmit(event) {
        event.preventDefault();

        const email = this.refs.email.value;
        const password = this.refs.password.value;
        this.props.loginUser({email, password}).then((data) => {
                if (data.payload.errorCode) {
                    this.setState({message: this.translateMessage(data.payload.errorMessage)});
                } else {
                    browserHistory.push('/driver-profile');
                }
            }
        );
    }

    loginWithProvider(provider) {
        this.props.loginWithProvider(provider).then((data) => {
            if (data.payload.errorCode) {
                this.setState({message: this.translateMessage(data.payload.errorMessage)});
            } else {
                browserHistory.push('/driver-profile');
            }
        });
    }

    render() {
        return (
            <div className="col-md-6">
                <div className="panel panel-default">
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe src="https://www.youtube.com/embed/DhL7P1grr7E?rel=0&amp;showinfo=0" frameBorder="0" allowFullScreen="allowfullscreen" />
                    </div>


                    <div className="panel-body">
                        <div className="alert alert-info"><p>Hľadáme vodičov na prepravu klientov po Bratislave</p><p>
                            Jazdíme na autách: Audi, Bmw, Mercedes, Volkswagen a Škoda</p><p>Výplata každý týždeň,
                            možnosť jazdiť na luxusných autách po zabehnutí.</p><p>Zaregistruj sa a do 24 hod sa Ti
                            ozveme.</p></div>
                        <form id="frmLogin" role="form" onSubmit={this.onFormSubmit}>
                            {(this.state.message) && (
                                <div className="alert alert-danger">{this.state.message}</div>
                            )}
                            <h2>Prihlásenie</h2>
                            <div className="form-group">
                                <label htmlFor="txtEmail">Emailová adresa</label>
                                <input
                                    type="email" className="form-control" id="txtEmail" ref="email"
                                    placeholder="Zadaj email"
                                    name="email"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="txtPass">Heslo</label>
                                <input
                                    type="password" className="form-control" id="txtPass" ref="password"
                                    placeholder="Heslo"
                                    name="password"
                                />
                            </div>
                            <button type="submit" className="btn btn-default btn-block">Prihlásiť</button>
                            <br />
                            <h5><Link to="/reset">Zabudnuté heslo?</Link></h5>


                        </form>
                    </div>
                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loginUser,
        fetchUser,
        loginWithProvider,
    }, dispatch);
}

function mapStateToProps(state) {
    return {currentUser: state.currentUser};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);



// WEBPACK FOOTER //
// ./src/app/components/user/login.jsx